import formInput from "@wielink-application/shared/js/mixins/formInput.js";
export default formInput;
